import AvatarDisplay from "components/avatar/display";
import { fullName } from "components/employee/utils";
import { ROLE_MAPPINGS } from "utils/role-format";

export const UserCell = ({ row }) => {
  return (
    <div className="gap-4 flex items-center w-100">
      <AvatarDisplay className="w-8 h-8" user={row.original} />

      <div className="space-y-0.5">
        <h3 className="text-sm font-medium leading-6 text-card-foreground">
          {fullName(row.original)}
        </h3>
        <p className="text-sm font-normal leading-5 text-muted-foreground">
          {row.original.user?.role?.name}{" "}
           • {row.original.grade?.name}{" "}
           • {row.original.function?.name}
        </p>
      </div>
    </div>
  );
};
